<woo-modal-layout size="medium" (close)="close()">
    <inline-group header gap="medium" class="alert-header">
        @if(status().style !== 'none') {
            <div class="icon-wrapper display--inline margin--none" [ngClass]="{
                'text-success status__badge success icon-success': status().style === 'success',
                'text-warning icon-warning-outline': status().style === 'warning',
                'text-danger icon-warning-outline': status().style === 'error'
              }">
                <span class="icon__large" [class.icon-check]="status().style === 'success'" [class.icon-warning-outline]="status().style === 'warning' || status().style === 'error'"></span>
            </div>
        }
        @if(status()?.title && status().title.length > 0) {
            <h3 class="alert-text" [class.title-padding]="status().style !== 'none'">{{status().title}}</h3>
        }
    </inline-group>
    @if(status().message) {
        <div class="status-margin-top">
            @for(msg of status().message; track $index;) {
                <p>{{msg}}</p>
            }
        </div>
    }
    <button id="close" [attr.e2e-id]="'close'" footer class="button primary-1 center display--block status-margin-top" (click)="close()">{{status().buttonLabel || 'Stäng'}}</button>
</woo-modal-layout>
